import { toast } from "react-toastify";

export const showToast = (message, icon) => {
    toast(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        className: "requiredToastError",
        icon: icon,
    });
};

export const showErrorToast = (message, icon) => {
    toast.error(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        className: "requiredToastError",
        icon: icon,
    });
};